import { render, staticRenderFns } from "./EditorElementInfo.vue?vue&type=template&id=5aaddc9e&lang=pug"
import script from "./EditorElementInfo.vue?vue&type=script&lang=js"
export * from "./EditorElementInfo.vue?vue&type=script&lang=js"
import style0 from "./EditorElementInfo.vue?vue&type=style&index=0&id=5aaddc9e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports